export const emptySession = () => ({ isLoggedIn: false, token: null, user: null, userId: null });
export function tokenClaims(token) {
  try {
    if (typeof token !== 'string' || token.split('.').length !== 3) return null;
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(payload.padEnd(Math.ceil(payload.length / 4) * 4, '=')));
  } catch { return null; }
}
// Client checks prevent stale UI; signature and access validation remain on the API.
export function normalizeSession(value, now = Date.now()) {
  const data = value?.data || value;
  const user = data?.user?.user || data?.user;
  const token = value?.token || data?.token || data?.user?.token;
  const claims = tokenClaims(token);
  const userId = user?._id || user?.id;
  if (!userId || !claims || !Number.isFinite(claims.exp) || claims.exp * 1000 <= now ||
    claims.id !== userId || user.active === false || user.isVerified === false) return emptySession();
  const safeUser = Object.fromEntries(['_id', 'id', 'first_name', 'last_name', 'email', 'phone', 'role', 'isVerified', 'active', 'picture', 'date_of_birth']
    .filter((key) => user[key] !== undefined).map((key) => [key, user[key]]));
  return { isLoggedIn: true, token, user: safeUser, userId };
}
export function authErrorMessage(error, fallback = 'Det gick inte att ansluta. Försök igen.') {
  if (typeof error?.data?.message === 'string') return error.data.message;
  if (Array.isArray(error?.data?.errors)) return error.data.errors.map((item) => item.message).filter(Boolean).join(' ') || fallback;
  return fallback;
}
export function safeReturnPath(value, fallback = '/account') {
  const path = typeof value === 'string' ? value : value?.pathname;
  return path?.startsWith('/') && !path.startsWith('//') && !path.includes('\\') && !path.startsWith('/auth/login') ? path : fallback;
}
